import { IInputValidator } from '../../interfaces/inputValidators/type';
import { injectable } from 'inversify';
// import { ValidationUtils } from '../../libraries/validationUtils';
import { IValidationInfo } from '../../dmInfoHandler/types';
import { IRenameDocument } from '../../docManager';
import { DCValidationError } from '../../customError/docComponentError';

@injectable()
export class JRAdapterRenameDocumentInputValidator implements IInputValidator {
    validationInfo: IValidationInfo;
    performValidation = (nodeObj: IRenameDocument): boolean => {
        // const validator = new ValidationUtils();

        if (nodeObj?.docId && nodeObj?.name) {
            return true;
        } else {
            throw new DCValidationError(
                'JR Passport. Rename Document Input Validation. Params: docId: ' +
                    nodeObj?.docId +
                    ' Name: ' +
                    nodeObj?.name,
            );
        }
    };
}
